import { IconLoader } from '@ui/src';
import { CardTypes } from './types';

import cn from './card.module.css';

const Card = ({
  title,
  isLoading,
  children,
  className,
  transparent,
  minHeight,
  wrapperClassName,
}: CardTypes) => {
  let content;

  if (isLoading) {
    content = (
      <div className={cn.cardLoader}>
        <IconLoader />
      </div>
    );
  } else {
    content = (
      <>
        <div className={cn.cardTitle}>{title}</div>
        <div
          className={`${cn.cardContent} ${className} ${
            transparent ? cn.cardContentTransparent : ''
          } ${minHeight ? cn.cardContentWithMinHeight : ''}`}
        >
          {children}
        </div>
      </>
    );
  }

  return (
    <div className={`${cn.card} ${wrapperClassName || ''}`}>{content}</div>
  );
};

export default Card;
